import type { Event } from '@sentry/react'

/**
 * How long the current document has been alive, in milliseconds.
 *
 * `performance.now()` counts from the document's time origin and is monotonic, so it is
 * unaffected by system clock changes. A reload or navigation starts a new document and
 * resets the count, and time spent with the tab in the background still counts.
 */
export function tabAgeMs(): number {
    return performance.now()
}

/**
 * Returns a copy of `event` annotated with how long the tab has been alive, so that errors
 * caused by long-lived tabs (stale state, expired tokens, dropped sockets) are recognisable.
 */
export function withTabAge<T extends Event>(event: T, ageMs: number): T {
    const ageSeconds = Math.max(0, Math.round(ageMs / 1000))

    return {
        ...event,
        contexts: { ...event.contexts, tabAge: { age_s: ageSeconds } },
    }
}
